import { useState, useEffect } from 'react';
import * as React from 'react';

//React Router
import { Navigate, useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom' //useParams to get the ref transmitted in the url



//created components
import HeaderStepManager from "../../../commons/headerstepmanager/HeaderStepManager.jsx";
import BannerMoutchicLoisirs from "../../../commons/bannerMoutchicLoisirs/BannerMoutchicLoisirs.jsx";
import BlocStockSemaine from "../../../components/blocstocksemaine/BlocStockSemaine.jsx";

import BlocJours from "../../../components/blocjours/BlocJours.jsx";
import LigneTotauxJours from "../../../components/lignetotauxjours/LigneTotauxJours.jsx";
import ModalContrat from "../../../components/modalcontrat/ModalContrat.jsx";
import ManagerNavBar from "../../../components/managernavbar/ManagerNavBar.jsx"; //<ManagerNavBar idSpotLoc={idSpotLoc} />

//MUI Components
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';

import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';

import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

//Redux tools and hooks
import { useSelector, useDispatch } from "react-redux";
import { idSpotLocSlice } from "../../../store/idSpotLocSlice.js";
import { spotsListSlice } from "../../../store/spotsListSlice.js";
import { getIdSpotLoc } from "../../../store/selectors.js";

// API fetch
import axios from "axios";
import { baseURL } from '../../../config/api-config.js';

//Utils
import { checkLogin } from '../../../utils/check-login.js'
//import Fetch API functions
import { getArticles, getAllContratsWeek, getOneSpot, getAccessoires, getStockPeriode } from '../../../database/fetchApi.js'

// tools and component for date picker
import dayjs from 'dayjs';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';


//import fr from 'dayjs/locale/fr';
const fr = require('dayjs/locale/fr')
dayjs.locale(fr);


const weekday = require('dayjs/plugin/weekday')
dayjs.extend(weekday)
const isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
dayjs.extend(isSameOrBefore)




function ManagerStocks() { // component to manage the first step of shopping : choosing place and time

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [dateRef, setDateRef] = useState();
    const [lundi, setLundi] = useState(dayjs().weekday(0));
    const [dimanche, setDimanche] = useState(dayjs().weekday(6));
    const [listContrats, setListContrats] = useState([]);
    const [filteredContrats, setFilteredContrats] = useState([]);
    const [articles, setArticles] = useState([]);
    const [accessoires, setAccessoires] = useState([]);
    const [stocksSemaine, setStocksSemaine] = useState([]);
    const [stockData, setStockData] = useState([]);
    const [contrats, setContrats] = useState([]);
    const [spotFilter, setSpotFilter] = useState(0);
    const [spotInfos, setSpotInfos] = useState();
    const [modeTri, setModeTri] = useState("alpha");
    const [allSpotsChecked, setAllSpotsChecked] = useState(true);
    let idSpotLoc = useSelector(getIdSpotLoc);




    useEffect(() => { //change opening hours when spot change (idspot as dependency)

        if (idSpotLoc === 0) { navigate("../manager/"); }

        if (checkLogin() === false) {
            navigate("/manager/login/stocks");
        }; // if no login, no token, go to login page

        async function initArticles() { //we add this inner function to manage asynchrone
            let allArticles = await getArticles();
            setArticles([].concat(allArticles))
            setDateRef(dayjs());
        } //end of async function
        initArticles(); //call the inner asnchrone function

        async function initAccess() { //we add this inner function to manage asynchrone
            let allAccess = await getAccessoires();
            setAccessoires(allAccess)
        } //end of async function
        initAccess(); //call the inner asnchrone function



    }, [])

    useEffect(() => { //change opening hours when spot change (idspot as dependency)

        setLundi(dayjs(dateRef).weekday(0));
        setDimanche(dayjs(dateRef).weekday(6));

        initStocks(dayjs(dateRef).weekday(0).format("YYYY-MM-DD"), dayjs(dateRef).weekday(6).format("YYYY-MM-DD")); //call the inner asnchrone function



    }, [dateRef])


    useEffect(() => { //change opening hours when spot change (idspot as dependency)
        initSpot(idSpotLoc); //call the inner asnchrone function
    }, [idSpotLoc])

    useEffect(() => { //
        console.log("wesh")
        stocksSemaine && getAllData(stocksSemaine);

    }, [allSpotsChecked])




    async function initSpot(id) { //we add this inner function to manage asynchrone
        let spotInfos = await getOneSpot(id);
        setSpotInfos(spotInfos)
    } //end of async function


    async function initStocks(date1, date2) { //we add this inner function to manage asynchrone
        let allStocks = await getStockPeriode(date1, date2);

        setStocksSemaine(allStocks)
        getAllData(allStocks);
    } //end of async function




    function getAllData(allStocks) {

        if (allSpotsChecked === false) {
            allStocks = [].concat(allStocks.filter(contrat => contrat.spot_id === idSpotLoc));
        }

        let stockSet = [];
        articles.forEach(article => {
            stockSet[article.id_article] = new Array(84);
        });

        let lundi = dayjs(dateRef).weekday(0);
        let dimanche = dayjs(dateRef).weekday(6);



        allStocks.map((contrat) => {

            // index => 7x12 = 84
            // on met toutes les infos de la semaine dans le même tableau pour un article => 84 creneaux
            //startIndex 0=>83
            let contratStartDayNumber = dayjs(contrat.date1).diff(dimanche, 'day') + 6;
            let contratStartIndex = contratStartDayNumber < 0 ? 0 : contratStartDayNumber * 12 + (contrat.h1 - 9);


            //endIndex 0=>83
            let contratEndDayNumber = dayjs(contrat.date2).diff(dimanche, 'day') + 6;
            let contratEndIndex = contratEndDayNumber * 12 + (contrat.h2 - 9);
            contratEndIndex = contratEndIndex > 83 ? 83 : contratEndIndex;


            contrat.ContratArticles.forEach(article => {

                for (let creneau = contratStartIndex; creneau <= contratEndIndex; creneau++) {

                    if (stockSet.length > 0) {
                        let amount = stockSet[article.article_id][creneau] || 0;
                        amount += article.qte;
                        stockSet[article.article_id][creneau] = amount;
                    }


                }
            });


        }) //end of map stocks semaine
        setStockData(stockSet);

    }




    return (
        <main>
            <BannerMoutchicLoisirs title={"Manager : Outil de réservation de vélos"} />
            <ManagerNavBar idSpotLoc={idSpotLoc} />
            <HeaderStepManager title={"Stocks de la semaine"} />



            <div className="manager-jour">

                <div className="manager-jour-top">
                    <div className="manager-jour-top-spot">
                        <p>Spot : {spotInfos && spotInfos.nom_spot}<i className={"list-contrat-tableau-ligne-spot-color" + idSpotLoc}></i></p> <i className={"ligne-contrat-tableau-ligne-spot-color-" + idSpotLoc}></i>
                        <FormControlLabel
                            className="manager-jour-top-spot-checkbox"
                            /* required */
                            control={<Checkbox
                                style={{
                                    color: "#00e676",
                                }}
                                onChange={_ => setAllSpotsChecked(!allSpotsChecked)}
                                checked={allSpotsChecked}
                            />}
                            label="Tous les spots"

                        />

                    </div>


                    <div className="manager-jour-header-nav">
                        {<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
                            <DatePicker
                                sx={{
                                    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { border: '1px solid #34B0EE' },                               // at page load
                                    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { border: '2px solid #362782' },  // at hover state
                                }}
                                value={dayjs(dateRef)}
                                label="Choisissez une date"
                                size="small"
                                onChange={(newValue) => setDateRef(dayjs(newValue))}
                                className='manager-jour-header-date-picker'
                            />
                        </LocalizationProvider>}

                        <KeyboardDoubleArrowLeftIcon className="manager-jour-header-nav-arrow" onClick={_ => setDateRef(dateRef.subtract(7, 'day'))} />
                        <p className="manager-semaine-header-nav-dates">du {lundi.format('dddd DD/MM')} au {dimanche.format('dddd DD/MM')}</p>
                        <KeyboardDoubleArrowRightIcon className="manager-jour-header-nav-arrow" onClick={_ => setDateRef(dateRef.add(7, 'day'))} />
                    </div>


                </div>

                <div className="manager-jour-bottom">


                    <div className="manager-jour-planning">
                        <BlocJours dateRef={dateRef} />

                        {
                            articles.map((article) => (
                                <div key={article.id_article}>
                                    <BlocStockSemaine article={article} dataSet={stockData[article.id_article] || []} dateRef={dateRef} />
                                </div>

                            ))
                        }

                    </div>


                </div>

            </div>



        </main>
    )
}




export default ManagerStocks